import ChalkySticks from '@chalkysticks/sdk';
import State from './State';

/**
 * Mutations are a synchronous way of modifying state. They are generally
 * called through Actions. It's best to think of them as setters.
 *
 * @see https://vuex.vuejs.org/guide/mutations.html
 *
 * @class Mutations
 * @package Store
 * @project ChalkySticks Pad
 */
const mutations = {
	/**
	 * @param State state
	 * @param boolean completed
	 * @return void
	 */
	setCompletedTutorial(state: typeof State, completed: boolean): void {
		state.completedTutorial = completed;
	},

	/**
	 * @param State state
	 * @param any payload
	 * @return void
	 */
	setDiagramState(state: typeof State, diagramState: ChalkySticks.Pad.Enum.DiagramState): void {
		state.diagramState = diagramState;
	},
};

export default mutations;
